import React, {Suspense} from 'react';
import LoadingBlock from './LoadingBlock';

const Loader = (props) => {
    return <Suspense fallback={<LoadingBlock />}>{props.children}</Suspense>
}

export default Loader;
